import { render } from "./VisualizarPlacarHomeView.vue?vue&type=template&id=5df5f955&scoped=true"
import script from "./VisualizarPlacarHomeView.vue?vue&type=script&lang=js"
export * from "./VisualizarPlacarHomeView.vue?vue&type=script&lang=js"

import "./VisualizarPlacarHomeView.vue?vue&type=style&index=0&id=5df5f955&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df5f955"]])

export default __exports__